import { z } from 'zod/v3';

// ============================================================================
// Terms Model 스키마
// ============================================================================

/**
 * 개별 약관 응답 스키마
 * @see GET /api/market-place/v2/terms
 */
export const marketTermsSchema = z.object({
  /** 외부 URL (약관 상세 페이지) */
  externalUrl: z.string(),
  /** 필수 동의 여부 */
  isRequired: z.boolean(),
  /** 릴리즈 ID */
  releaseId: z.number(),
  /** 약관 제목 */
  title: z.string(),
  /** 약관 유형 */
  type: z.string(),
});
export type MarketTerms = z.infer<typeof marketTermsSchema>;

/**
 * 약관 번들 (루트) 스키마
 * @description 약관 그룹 정보
 */
export const termsRootSchema = z.object({
  /** 약관 항목 목록 */
  elements: z.array(marketTermsSchema),
  /** 번들 제목 */
  title: z.string(),
  /** 번들 유형 */
  type: z.string(),
});
export type TermsRoot = z.infer<typeof termsRootSchema>;

/**
 * 약관 조회 응답 스키마
 * @see GET /api/market-place/v2/terms
 */
export const termsResponseSchema = z.object({
  /** 약관 번들 목록 */
  elements: z.array(termsRootSchema),
  /** 성공 여부 */
  success: z.boolean(),
});
export type TermsResponse = z.infer<typeof termsResponseSchema>;

/**
 * 약관 동의 요청 스키마
 * @see POST /api/market-place/v2/terms/agree
 */
export const agreeTermsRequestSchema = z.object({
  /** 약관 릴리즈 ID */
  releaseId: z.number(),
  /** UUID */
  uuid: z.string(),
});
export type AgreeTermsRequest = z.infer<typeof agreeTermsRequestSchema>;
